const triggerAIAssistantEvent = (description: string, type: string, conversationId: string | null) => {
  try {
    window?._ddm?.trigger('fe.ga_event', {
      data: {
        type: 'user_event',
        interaction: {
          event: 'ai_assistant',
          type,
          description,
          text: undefined,
          status: 'success',
          detail: { conversationId },
          metadata: {},
        },
        component: {
          technical_name: 'aiassistant',
          meaningful_name: 'ai_assistant',
          location: window?.location?.pathname,
          id: undefined,
          type: 'widget',
        },
      },
    });
  } catch {
    // silent fail — DDM may not be loaded
  }
};

export const trackConversationInputReset = (conversationId: string | null) => {
  triggerAIAssistantEvent('conversation input reset', 'click', conversationId);
};

export const trackConversationWindowMinimized = (conversationId: string | null) => {
  triggerAIAssistantEvent('conversation window minimized', 'click', conversationId);
};
